import { InlineNotification, LoadingIndicator, RecordContent } from '@msaf/core-react'
import { useParams } from 'react-router-dom'
import { useViewRedirectGatekeeper } from '../../../../components/gatekeeper'
import { useWorkflowGatekeeper } from '../../../../forms/application/utils'
import { UserPermissions } from '../../../../types/permissions'
import { ApplicationRouteParams } from '../../../../types/route'
import { ApplicationWrapper } from './application-wrapper'

export const SupplySectionWrapper = () => {
  const { id: planId, applicationId, mode } = useParams<ApplicationRouteParams>()
  useViewRedirectGatekeeper(UserPermissions.EDIT_SUPPLY, UserPermissions.VIEW_SUPPLY)

  const { isLoading, open } = useWorkflowGatekeeper(planId, applicationId, 'supply', mode)

  if (isLoading) return <LoadingIndicator />

  if (!open) {
    return (
      <RecordContent>
        <InlineNotification isDismissable={false}>Not submitted</InlineNotification>
      </RecordContent>
    )
  }

  return <ApplicationWrapper />
}
